import React from "react";
import Modal from "./Modal";

const ConfirmModal = ({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  children,
  maxWidth = "max-w-md",
  danger = false,
}) => (
  <Modal open={open} onClose={onCancel} className={`relative p-6 sm:p-8 ${maxWidth}`}>
    {title && <h2 className="text-xl font-semibold text-on-primary-fixed-var mb-4">{title}</h2>}
    {message && <p className="text-on-surface-variant mb-4">{message}</p>}
    {children}

    {(onConfirm || onCancel) && (
      <div className="flex justify-between space-x-4 mt-4">
        {onCancel && cancelLabel && (
          <button
            className="flex-1 text-on-primary-fixed-var bg-surface-low border border-surface-container p-3 rounded-xl hover:bg-surface-container transition-colors font-medium text-sm"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
        )}
        {onConfirm && (
          <button
            className={`flex-1 text-white p-3 rounded-xl transition-colors font-semibold text-sm ${
              danger ? "bg-red-500 hover:bg-red-600" : "bg-primary hover:bg-primary-container"
            }`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        )}
      </div>
    )}
  </Modal>
);

export default ConfirmModal;
